import { rgb, PageSizes } from 'pdf-lib'
import genmincho from '../../font/SourceHanSerif-Medium_extracted.otf'
import genmincho_bold from '../../font/SourceHanSerif-Bold_extracted.otf'
import fontkit from '@pdf-lib/fontkit'

import { dayWeekToString, decimalToPercentDecimal, getAmPmHour, getMonthDateDisplay, getYearMonthDateDisplay } from '../../utils/utils'
import { createPDFDocument, customDrawText, getFontArrayBuffer} from './pdf_create'
import { drawTextInBox,  X_ALIGN_CENTER, X_ALIGN_RIGHT, X_ALIGN_LEFT, Y_ALIGN_BOTTOM } from './pdfUtil/drawTextInBox.js'
import { getDisplayOriginWithOther, getDisplaySize } from '../../utils/Items'
import { postMarketPriceSearchInfoListAPI, postMarketPriceSearchTableInfoListAPI } from '../../http/api/MarketPriceAPI'
import { getShopsGroupingByCustomer } from '../../utils/customerShop'
import { DELIVERY_PRICE_ADDITION_CD_RATE, filterPartition, getDeliveryPriceCalculation, getOutputDestination, getOutputShippingDate, getPrimePrice, getPrintPages, getProductPartitionList, getSellingPrice, sampleDestination } from '../../utils/orderForm'
import { getDaysBetween } from '../../utils/calendar'
import Decimal from 'decimal.js'

export const getHorizontalOrderFormPageParameter = (width, height, fonts, shops, destinations, shippingDateInfo, pdfSetting) => {

  const {columnNumber, shopSummary, productTypePartition, unitPrice, contact, deadlineHourOutput, orderQuantityOutput, skipOrderUnit, datePartition, skipRemark, isUsingSellingPrice, isUsingDeliveryPrice, isUsingOriginalMarketPrice, isViewOriginalCost, isSendingAgain, printPageStr, outputPrice, asSendingLabel} = pdfSetting;
  const margin = 20

  const headerHeight = 50
  const tableStart_y = height - margin - headerHeight

  const footerHeight = 25
  const tableEnd_y = margin + footerHeight

  const rowNumber = 21

  const destinationNumber = destinations.length;
  
  let shopNumber = shops.length;

  const dateList = datePartition
    ? getDaysBetween(shippingDateInfo.shippingDateFrom, shippingDateInfo.shippingDateTo)
    : [];
  
  const shopNames= shops.map((shopInfo) => shopInfo.shopName);

  const customerShopList = getShopsGroupingByCustomer(shops);
  const outputCustomerName = shopSummary && customerShopList.length >= 2;

  let tableHeaderRowSpan = 1;  
  let orderQuantityColumnNumber = 1;

  if (!orderQuantityOutput) {
    orderQuantityColumnNumber = 0;
  } else if (datePartition) {
    tableHeaderRowSpan = 1.3;
    orderQuantityColumnNumber = dateList.length;
  } else if (shopSummary) {
    tableHeaderRowSpan = (outputCustomerName ? 2 : 1);
    orderQuantityColumnNumber = shops.length;
  }

  const rowHeight = (tableStart_y - tableEnd_y) / (rowNumber + tableHeaderRowSpan)
  const tableHeaderHeight = rowHeight * tableHeaderRowSpan;
  const tableDataStart_y = tableStart_y - tableHeaderHeight;
  const shopHeaderStart_y =  tableDataStart_y + rowHeight;

  // （印刷用紙幅 - 左右余白マージン）/ １ページあたりの列分割数 
  const columnWidth = (width - 2 * margin) / columnNumber;

  let shopColumnWidth;
  // 1店舗辺りの出力列幅
  if (asSendingLabel) {
    shopColumnWidth = columnWidth * columnNumber * 0.09
  } else {
    shopColumnWidth = columnWidth * columnNumber * (shopSummary ? 0.05 : 0.045);
  }

  // 納品価格欄・案内価格欄
  let originalMarketPriceLeft = columnWidth;
  if (outputPrice && isUsingOriginalMarketPrice) {
    originalMarketPriceLeft = columnWidth * (columnNumber === 1 ? 0.94 : 0.89);
  }

  let remarkColumnLeft = originalMarketPriceLeft;
  if (!skipRemark) {
    remarkColumnLeft = originalMarketPriceLeft * (1 - 0.085 * columnNumber);
  }

  const orderUnitColumnLeft = remarkColumnLeft - shopColumnWidth * orderQuantityColumnNumber;

    // 価格欄レイアウト
    let nameColumnLeft, placeColumnLeft, sizeColumnLeft, priceColumnLeft = 0;
    let primePriceLeft, sellingPriceMarkUpRateLeft, sellingPriceLeft = 0;
  
    if (outputPrice && isUsingSellingPrice && !isViewOriginalCost) {
      nameColumnLeft = orderUnitColumnLeft * 0;
      placeColumnLeft = orderUnitColumnLeft * 0.25;
      sizeColumnLeft = orderUnitColumnLeft * 0.4;
      priceColumnLeft = orderUnitColumnLeft * 0.58;
      sellingPriceLeft = orderUnitColumnLeft * 0.58;
      primePriceLeft = orderUnitColumnLeft * 0.73;
      sellingPriceMarkUpRateLeft = orderUnitColumnLeft * 0.88;
    } else if (outputPrice) {        
      nameColumnLeft = orderUnitColumnLeft * 0
      placeColumnLeft = orderUnitColumnLeft * 0.4
      sizeColumnLeft = orderUnitColumnLeft * 0.62
      priceColumnLeft = orderUnitColumnLeft * 0.84
    } else {
      nameColumnLeft = orderUnitColumnLeft * 0
      placeColumnLeft = orderUnitColumnLeft * 0.5
      sizeColumnLeft = orderUnitColumnLeft * 0.73
      priceColumnLeft = orderUnitColumnLeft * 1
    }

  const tableCellPadding = 3;

  return {
    ...pdfSetting,
    width,
    height,
    margin,
    headerHeight,
    tableStart_y ,  
    footerHeight ,
    tableEnd_y ,  
    rowNumber ,
    columnNumber ,
    shopNumber,
    rowHeight ,
    tableHeaderHeight,
    shopHeaderStart_y,
    tableDataStart_y,
    columnWidth ,
    nameColumnLeft ,
    placeColumnLeft ,
    sizeColumnLeft ,
    priceColumnLeft ,
    orderUnitColumnLeft,
    remarkColumnLeft,
    shopColumnWidth,
    fonts,
    shopNames,
    destinations,
    destinationNumber,
    shops,
    customerShopList,
    contact,
    deadlineHourOutput,
    orderQuantityOutput,
    skipOrderUnit,
    outputCustomerName,
    shopSummary,
    productTypePartition,
    tableCellPadding,
    unitPrice,
    orderQuantityColumnNumber,
    dateList,
    isUsingSellingPrice,
    primePriceLeft,
    sellingPriceMarkUpRateLeft,
    sellingPriceLeft,
    isUsingOriginalMarketPrice,
    originalMarketPriceLeft,
    isUsingDeliveryPrice,
    isViewOriginalCost,
    isSendingAgain,
    printPageStr
  }
}

// 価格表　ヘッダ部分作成
export const createHorizontalOrderFormHeader = (marketPriceInfo, page, title, destination, shippingDateInfo, pageParameter) => {

  const {
    width,
    height,
    margin,
    tableStart_y,
    fonts,
    isUsingDeliveryPrice,
    isUsingOriginalMarketPrice,
    isSendingAgain,
    outputPrice,
    asSendingLabel
  } = pageParameter;
  const { deliveryPriceAdditionCd, deliveryPriceAdditionAmount } = marketPriceInfo;

  const todayStr = getYearMonthDateDisplay(new Date());
  const shippingDateStr = getOutputShippingDate(shippingDateInfo.shippingDateFrom, shippingDateInfo.shippingDateTo);

  // 担当者
  if(pageParameter.directorEmployee){
    customDrawText(page, `担当者：${pageParameter.directorEmployee}`, {
      x: margin,
      y: height - margin - 5,
      size: 10,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    });}  

  // 発行日
  if (!asSendingLabel) {
    customDrawText(page, todayStr, {
      x: width - margin - 7 * todayStr.length,
      y: height - margin - 10,
      size: 10,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    });
  }

  // あて名
  customDrawText(page, destination, {
    x: margin,
    y: height - margin - 25,
    size: 15,
    font: fonts.mincho_font,
    color: rgb(0, 0, 0),
  })
  
  // タイトル
  customDrawText(page, title, {
    x: width / 2 - title.length * 9,
    y: height - margin - 45,
    size: 18,
    font: fonts.mincho_bold_font,
    color: rgb(0, 0, 0),
  })

  // 再送
  if (isSendingAgain) {
    drawTextInBox(
      page, 
      "再送",
      {x1: width - margin - 125, x2: width - margin - 85, y1: height - margin, y2: height - margin - 17 },
      {xAlign: X_ALIGN_RIGHT, yAlign: Y_ALIGN_BOTTOM, font: fonts.mincho_bold_font, size: 18, shrink: false}
    )

    page.drawLine({
      start: { x: width - margin - 125, y: height - margin - 17 },
      end: { x:width - margin - 85, y: height - margin - 17 },
      thickness : 1,
      color: rgb(0, 0, 0),
      opacity : 1
    })

    page.drawLine({
      start: { x: width - margin - 125, y: height - margin - 19 },
      end: { x:width - margin - 85, y: height - margin - 19 },
      thickness : 1,
      color: rgb(0, 0, 0),
      opacity : 1
    })
  }

  customDrawText(page,'納品日：' + shippingDateStr, {
    x: width - margin - (shippingDateInfo.shippingDateTo ? 250 : 140),
    y: height - margin - 45,
    size: 12,
    font: fonts.mincho_font,
    color: rgb(0, 0, 0),
  })

  // 納品価格注意
  if (outputPrice && isUsingDeliveryPrice && isUsingOriginalMarketPrice) {

    Decimal.rounding = Decimal.ROUND_HALF_CEIL;

    /** 納品価格増量分の説明 */
    let additionExplanation =
      (deliveryPriceAdditionCd === DELIVERY_PRICE_ADDITION_CD_RATE) 
        ? `各案内価格の${decimalToPercentDecimal(new Decimal(deliveryPriceAdditionAmount))}%`
        : `各商品に対し${parseInt(new Decimal(deliveryPriceAdditionAmount).round().toNumber())}円`;

    customDrawText(page,`※手数料として、${additionExplanation}を頂戴いたします`, {
      x: width - margin - 260,
      y: height - margin - 28,
      size: 10,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    })

  }
}

// 価格表の骨格作成
export const createHorizontalOrderFormTableBones = (page, pageParameter) => {

  const {
    width,
    margin,
    tableStart_y,
    tableEnd_y,
    rowNumber,
    columnNumber,
    rowHeight,
    columnWidth,
    nameColumnLeft,
    placeColumnLeft,
    sizeColumnLeft,
    priceColumnLeft,
    orderUnitColumnLeft,
    remarkColumnLeft,
    shopColumnWidth,
    fonts,
    shops,
    shopSummary,
    tableCellPadding,
    outputCustomerName,
    tableHeaderHeight,
    tableDataStart_y,
    shopHeaderStart_y,
    orderQuantityOutput,
    unitPrice,
    dateList,
    datePartition,
    skipRemark,
    isUsingSellingPrice,
    sellingPriceMarkUpRateLeft,
    primePriceLeft,
    originalMarketPriceLeft,
    isUsingOriginalMarketPrice,
    isUsingDeliveryPrice,
    isViewOriginalCost,
    outputPrice,
    asSendingLabel
  } = pageParameter

  const SHOP_NAME_SPLIT_LENGTH = 5;
  function splitShopName(shopName) {
    if (shopName && shopName.length > SHOP_NAME_SPLIT_LENGTH) {
      return [shopName.slice(0, SHOP_NAME_SPLIT_LENGTH), shopName.slice(SHOP_NAME_SPLIT_LENGTH)];
    } else {
      return [shopName];
    }
  }   

  // 横罫線
  page.drawLine({
    start: { x: margin, y: tableStart_y },
    end: { x: width - margin, y: tableStart_y },
    thickness : 2,
    color: rgb(0, 0, 0),
    opacity : 1
  })

  Array.from(new Array(rowNumber)).forEach((_, index) => {
    page.drawLine({
      start: { x: margin, y: tableDataStart_y - rowHeight * index},
      end: { x: width - margin, y: tableDataStart_y  - rowHeight * index},
      thickness : 1,
      color: rgb(0, 0, 0),
      opacity : 1
    })
  })

  page.drawLine({
    start: { x: margin, y: tableEnd_y },
    end: { x: width - margin, y: tableEnd_y },
    thickness : 2,
    color: rgb(0, 0, 0),
    opacity : 1
  })

  // 縦罫線と表ヘッダ
  Array.from(new Array(columnNumber)).forEach((_, index) => {

    let start_x = margin + columnWidth * index;

    page.drawLine({
      start: { x: start_x, y: tableStart_y},
      end: { x: start_x, y: tableEnd_y},
      thickness : 2,
      color: rgb(0, 0, 0),
      opacity : 1
    })

    page.drawLine({
      start: { x: start_x + nameColumnLeft, y: tableStart_y},
      end: { x: start_x + nameColumnLeft, y: tableEnd_y},
      thickness : 1,
      color: rgb(0, 0, 0),
      opacity : 1
    })

    customDrawText(page,'商品名', {
      x: start_x + (nameColumnLeft + placeColumnLeft) / 2 - 15,
      y: tableStart_y - tableHeaderHeight / 2 - tableCellPadding,
      size: 10,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    })
    
    page.drawLine({
      start: { x: start_x + placeColumnLeft, y: tableStart_y},
      end: { x: start_x + placeColumnLeft, y: tableEnd_y},
      thickness : 1,
      color: rgb(0, 0, 0),
      opacity : 1
    })

    customDrawText(page,'産地', {
      x: start_x + (placeColumnLeft + sizeColumnLeft) / 2 - 10,
      y: tableStart_y - tableHeaderHeight / 2 - tableCellPadding,
      size: 10,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    })

    page.drawLine({
      start: { x: start_x + sizeColumnLeft, y: tableStart_y},
      end: { x: start_x + sizeColumnLeft, y: tableEnd_y},
      thickness : 1,
      color: rgb(0, 0, 0),
      opacity : 1
    })

    customDrawText(page,'規格', {
      x: start_x + (sizeColumnLeft + priceColumnLeft) / 2 - 10,
      y: tableStart_y - tableHeaderHeight / 2 - tableCellPadding,
      size: 10,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    })

    page.drawLine({
      start: { x: start_x + priceColumnLeft, y: tableStart_y},
      end: { x: start_x + priceColumnLeft, y: tableEnd_y},
      thickness : 1,
      color: rgb(0, 0, 0),
      opacity : 1
    })

    // 価格欄
    // 売価表示設定かつ営業用出力でない場合
    if (outputPrice && isUsingSellingPrice && !isViewOriginalCost) {
      page.drawLine({
        start: { x: start_x + primePriceLeft, y: tableStart_y},
        end: { x: start_x + primePriceLeft, y: tableEnd_y},
        thickness : 1,
        color: rgb(0, 0, 0),
        opacity : 1
      });

      page.drawLine({
        start: { x: start_x + sellingPriceMarkUpRateLeft, y: tableStart_y},
        end: { x: start_x + sellingPriceMarkUpRateLeft, y: tableEnd_y},
        thickness : 1,
        color: rgb(0, 0, 0),
        opacity : 1
      });

      drawTextInBox(page, '売価', {
        x1: start_x + priceColumnLeft,
        x2: start_x + primePriceLeft,
        y1: tableStart_y,
        y2: tableStart_y - tableHeaderHeight + 2
      },{
        size: 12,
        font: fonts.mincho_font,
        xAlign: X_ALIGN_CENTER
      });

      drawTextInBox(page, '原価', {
        x1: start_x + primePriceLeft,
        x2: start_x + sellingPriceMarkUpRateLeft,
        y1: tableStart_y,
        y2: tableStart_y - tableHeaderHeight + 2
      },{
        size: 12,
        font: fonts.mincho_font,
        xAlign: X_ALIGN_CENTER
      });

      drawTextInBox(page, '値入', {
        x1: start_x + sellingPriceMarkUpRateLeft,
        x2: start_x + orderUnitColumnLeft,
        y1: tableStart_y,
        y2: tableStart_y - tableHeaderHeight + 2
      },{
        size: 12,
        font: fonts.mincho_font,
        xAlign: X_ALIGN_CENTER
      });

    } else if (outputPrice) {
      let unitPriceTitle = unitPrice === 2 ? 'キロ単価' : '価格';

      if (isUsingDeliveryPrice) {
        unitPriceTitle = isUsingOriginalMarketPrice ? "納品価格" : "案内価格";
      }

      drawTextInBox(page, unitPriceTitle, {
        x1: start_x + priceColumnLeft,
        x2: start_x + orderUnitColumnLeft,
        y1: tableStart_y,
        y2: tableStart_y - tableHeaderHeight + 2
      },{
        size: 10,
        font: fonts.mincho_font,
        xAlign: X_ALIGN_CENTER
      })
    }

    page.drawLine({
      start: { x: start_x + orderUnitColumnLeft , y: tableStart_y},
      end: { x: start_x + orderUnitColumnLeft  , y: tableEnd_y},
      thickness : 1,
      color: rgb(0, 0, 0),
      opacity : 1
    })

    // 店舗別・日付別注文数
    if (orderQuantityOutput) {

      page.drawLine({
        start: { x: start_x + orderUnitColumnLeft + 2, y: tableStart_y},
        end: { x: start_x + orderUnitColumnLeft + 2 , y: tableEnd_y},
        thickness : 1,
        color: rgb(0, 0, 0),
        opacity : 1
      })

      if (datePartition) {
        dateList.forEach((date, dateIndex) => {
          let monthDate = getMonthDateDisplay(date);
          let day = dayWeekToString(date.getDay())

          page.drawLine({
            start: { x: start_x + orderUnitColumnLeft + shopColumnWidth * dateIndex, y: tableStart_y},
            end: { x: start_x + orderUnitColumnLeft + shopColumnWidth * dateIndex , y: tableEnd_y},
            thickness : 1,
            color: rgb(0, 0, 0),
            opacity : 1
          });

          drawTextInBox(page, monthDate, {
            x1: start_x + orderUnitColumnLeft + shopColumnWidth * dateIndex,
            x2: start_x + orderUnitColumnLeft + shopColumnWidth * (dateIndex + 1),
            y1: tableStart_y,
            y2: tableStart_y - tableHeaderHeight / 2
          },{
            size: 8,
            xAlign: X_ALIGN_CENTER,
            font: fonts.mincho_bold_font,
            color: rgb(0, 0, 0)
          })

          drawTextInBox(page, day, {
            x1: start_x + orderUnitColumnLeft + shopColumnWidth * dateIndex,
            x2: start_x + orderUnitColumnLeft + shopColumnWidth * (dateIndex + 1),
            y1: tableStart_y - tableHeaderHeight / 2 + 2,
            y2: tableStart_y - tableHeaderHeight + 2
          },{
            size: 8,
            xAlign: X_ALIGN_CENTER,
            font: fonts.mincho_bold_font,
            color: rgb(0, 0, 0),
          })
        });   

      } else if (shopSummary) {
        page.drawLine({
          start: { x: margin + orderUnitColumnLeft, y: tableStart_y - rowHeight },
          end: { x: margin + remarkColumnLeft, y: tableStart_y - rowHeight },
          thickness : 1,
          color: rgb(0, 0, 0),
          opacity : 1
        })
  
        let lastCustomerId = 0;
  
        shops.forEach((shopInfo, shopIndex) => {
          let customerName = shopInfo.customerName;
          let shopName = shopInfo.shopName;
  
          if (outputCustomerName && lastCustomerId !== shopInfo.customerId) {
  
            page.drawLine({
              start: { x: start_x + orderUnitColumnLeft + shopColumnWidth * shopIndex, y: tableStart_y},
              end: { x: start_x + orderUnitColumnLeft + shopColumnWidth * shopIndex, y: tableEnd_y},
              thickness : 1,
              color: rgb(0, 0, 0),
              opacity : 1
            })
  
            page.drawLine({
              start: { x: start_x + orderUnitColumnLeft + shopColumnWidth * shopIndex + 2, y: tableStart_y},
              end: { x: start_x + orderUnitColumnLeft + shopColumnWidth * shopIndex + 2 , y: tableEnd_y},
              thickness : 1,
              color: rgb(0, 0, 0),
              opacity : 1
            })
  
            customDrawText(page,customerName, {
              x: start_x + orderUnitColumnLeft + shopColumnWidth * shopIndex + 4,
              y: tableStart_y - rowHeight / 2 - 4,
              size: 8,
              font: fonts.mincho_font,
              color: rgb(0, 0, 0),
            })
  
          } else {
            page.drawLine({
              start: { x: start_x + orderUnitColumnLeft + shopColumnWidth * shopIndex, y: shopHeaderStart_y},
              end: { x: start_x + orderUnitColumnLeft + shopColumnWidth * shopIndex , y: tableEnd_y},
              thickness : 1,
              color: rgb(0, 0, 0),
              opacity : 1
            })
          }
            
          if(shopName.length>=SHOP_NAME_SPLIT_LENGTH){
            splitShopName(shopName).map((text,index)=>{
              customDrawText(page,text, {
                x: start_x + orderUnitColumnLeft + shopColumnWidth * (shopIndex + 1/2) - 20,
                y: shopName.length == 5 
                ? (shopHeaderStart_y - rowHeight / 2 - tableCellPadding)
                : (shopHeaderStart_y - rowHeight / 3 - tableCellPadding -(10*index)),
                size: 8,
                font: fonts.mincho_bold_font,
                color: rgb(0, 0, 0),
              })
            })
          } else {
            customDrawText(page,shopName, {
              x: start_x + orderUnitColumnLeft + shopColumnWidth * (shopIndex + 1 / 2) - shopName.length * 5,
              y: shopHeaderStart_y - rowHeight * 1 / 2 - 5,
              size: 10,
              font: fonts.mincho_bold_font,
              color: rgb(0, 0, 0),
            })
          }
              
          lastCustomerId = shopInfo.customerId;
    
        });
  
      } else if (asSendingLabel) {
  
        customDrawText(page,"納品数", {
          x: start_x + (orderUnitColumnLeft + remarkColumnLeft) / 2 - 15,
          y: tableStart_y - tableHeaderHeight / 2 - tableCellPadding,
          size: 10,
          font: fonts.mincho_font,
          color: rgb(0, 0, 0),
        })
      } else {
  
        customDrawText(page,"発注数量", {
          x: start_x + (orderUnitColumnLeft + remarkColumnLeft) / 2 - 16,
          y: tableStart_y - tableHeaderHeight / 2 - tableCellPadding,
          size: 8,
          font: fonts.mincho_font,
          color: rgb(0, 0, 0),
        })
      }
    }

    // 備考
    if (!skipRemark) {
      page.drawLine({
        start: { x: start_x + remarkColumnLeft, y: tableStart_y},
        end: { x: start_x + remarkColumnLeft, y: tableEnd_y},
        thickness : 1,
        color: rgb(0, 0, 0),
        opacity : 1
      })

      customDrawText(page,'備考', {
        x: start_x + (remarkColumnLeft + originalMarketPriceLeft) / 2 - (columnNumber === 1 ? 12 : 8),
        y: tableStart_y - tableHeaderHeight / 2 - 4,
        size: columnNumber === 1 ? 12 : 8,
        font: fonts.mincho_font,
        color: rgb(0, 0, 0),
      })
    }

    
    // 納品価格・案内価格
    if (outputPrice && isUsingOriginalMarketPrice) {
      page.drawLine({
        start: { x: start_x + originalMarketPriceLeft, y: tableStart_y},
        end: { x: start_x + originalMarketPriceLeft, y: tableEnd_y},
        thickness : 1,
        color: rgb(0, 0, 0),
        opacity : 1
      })

      // 売価表示設定でない場合は案内価格を表示
      // 売価表示設定かつ営業用出力ではない場合は仲卸業者への納品価格を表示
      // 売価表示設定かつ営業用出力である場合は案内価格を表示
      drawTextInBox(page, (isUsingSellingPrice && !isViewOriginalCost) ? "納品価格": "案内価格", {
        x1: start_x + originalMarketPriceLeft,
        x2: start_x + columnWidth,
        y1: tableStart_y,
        y2: tableStart_y - tableHeaderHeight + 2
      },{
        size: 10,
        xAlign: X_ALIGN_CENTER,
        font: fonts.mincho_font,
      })
    }
  })

  page.drawLine({
    start: { x: width - margin, y: tableStart_y},
    end: { x: width - margin, y: tableEnd_y},
    thickness : 2,
    color: rgb(0, 0, 0),
    opacity : 1
  })
}

// 価格表データ出力
export const outputHorizontalOrderFormTableProductData = (page, pageParameter, rowIndex, columnIndex, outputData) => {

  const {
    margin,
    tableStart_y ,  
    rowHeight ,
    columnWidth ,
    shopColumnWidth,
    nameColumnLeft,
    placeColumnLeft ,
    sizeColumnLeft ,
    priceColumnLeft,
    orderUnitColumnLeft,
    remarkColumnLeft,
    fonts,
    shopNumber,
    tableCellPadding,
    tableDataStart_y,
    skipOrderUnit,
    orderQuantityOutput,
    orderQuantityColumnNumber,
    skipRemark,
    isUsingSellingPrice,
    sellingPriceMarkUpRateLeft,
    primePriceLeft,
    isUsingOriginalMarketPrice,
    originalMarketPriceLeft,
    isUsingDeliveryPrice,
    isViewOriginalCost,
    outputPrice
  } = pageParameter;

  const {
    name,
    origin,
    rank,
    productClass,
    weight,
    weightUnit,
    packing,
    quantity,
    isShortage,
    price,
    primePriceMarkUpRate,
    sellingPriceMarkUpRate,
    unit,
    remarks,
    outputAsFirstOfType,
    deliveryPriceAdditionCd,
    deliveryPriceAdditionAmount
  } = outputData;

  const dataStart_x = margin + columnWidth * columnIndex

  const text_y = tableDataStart_y - rowHeight * (rowIndex + 1 / 2) - 4
  let text_y1 = tableDataStart_y - rowHeight * rowIndex

  let outputOrigin = origin ? origin : "";

  let outputUnit = unit ? unit: "";

  let outputSize_1 = "";
  let outputSize_2 = "";

  let outputWeight = weightUnit ? weight.toString() + weightUnit : "";

  Array.from([rank, productClass, outputWeight, packing, quantity]).forEach((item) => {
    if (item && item.length > 0) {
      if (outputSize_2.length > 0 || (outputSize_1.length > 0 && outputSize_1.length + item.length > 8)) {
        outputSize_2 += item + " ";        
      } else {
        outputSize_1 += item + " ";
      }
    }
  })

  if (outputAsFirstOfType) {
    page.drawLine({
      start: { x: dataStart_x, y: tableDataStart_y - rowHeight * rowIndex - 2 },
      end: { x: dataStart_x + columnWidth,  y: tableDataStart_y - rowHeight * rowIndex - 2},
      thickness : 1,
      color: rgb(0, 0, 0),
      opacity : 1
    })
  }
 
  let textInBoxOption = {
    font: fonts.mincho_font,
    size: 10,
    xPadding: 0,
    yPadding: 0,
    xAlign: X_ALIGN_CENTER
  } 

  // 商品名
  drawTextInBox(page, name, {
    x1: dataStart_x + nameColumnLeft,
    x2: dataStart_x + placeColumnLeft,
    y1: text_y1,
    y2: text_y1 - rowHeight + 2
  },{
    ...textInBoxOption,
    size: 12,
    font: fonts.mincho_bold_font
  });

  // 産地
  drawTextInBox(page, outputOrigin, {
    x1: dataStart_x + placeColumnLeft,
    x2: dataStart_x + sizeColumnLeft,
    y1: text_y1,
    y2: text_y1 - rowHeight + 2
  }, textInBoxOption);

  // 規格
  if (outputSize_2.length > 0) {
    drawTextInBox(page, outputSize_1, {
      x1: dataStart_x + sizeColumnLeft,
      x2: dataStart_x + priceColumnLeft,
      y1: text_y1,
      y2: text_y1 - rowHeight / 2
    }, {
      ...textInBoxOption,
      size: 9
    });

    drawTextInBox(page, outputSize_2, {
      x1: dataStart_x + sizeColumnLeft,
      x2: dataStart_x + priceColumnLeft,
      y1: text_y1 - rowHeight / 2,
      y2: text_y1 - rowHeight + 2
    }, {
      ...textInBoxOption,
      size: 9
    });
  } else {
    drawTextInBox(page, outputSize_1, {
      x1: dataStart_x + sizeColumnLeft,
      x2: dataStart_x + priceColumnLeft,
      y1: text_y1,
      y2: text_y1 - rowHeight + 2
    }, {
      ...textInBoxOption,
      size: 9
    });
  }
  
  //  価格
  // 価格表示設定かつ売価表示設定かつ営業用出力でない場合
  if(outputPrice && isUsingSellingPrice && !isViewOriginalCost) {
    // 納品価格加算を加算する場合は納品価格を計算　※ただし、入荷未定の場合は計算不可
    let displayPrice = (!isShortage && isUsingDeliveryPrice) ? getDeliveryPriceCalculation(deliveryPriceAdditionCd)(price, deliveryPriceAdditionAmount) : price;

    let displayPrimePrice = isShortage ? "-" : getPrimePrice(displayPrice, primePriceMarkUpRate).toLocaleString();
    let displaySellingPriceMarkUpRate = isShortage ? "-" : decimalToPercentDecimal(new Decimal(sellingPriceMarkUpRate)).toFixed(2);
    let displaySellingPrice = isShortage ? "-" : getSellingPrice(displayPrice, primePriceMarkUpRate, sellingPriceMarkUpRate).toLocaleString();

    // 売価
    drawTextInBox(page, displaySellingPrice, {
      x1: dataStart_x + priceColumnLeft,
      x2: dataStart_x + primePriceLeft,
      y1: text_y1,
      y2: text_y1 - rowHeight + 2
    }, {
      ...textInBoxOption,
      font: fonts.mincho_bold_font,
      xAlign: X_ALIGN_RIGHT,
      xPadding: 2,
      size: 12
    });

    // 原価
    drawTextInBox(page, displayPrimePrice, {
      x1: dataStart_x + primePriceLeft,
      x2: dataStart_x + sellingPriceMarkUpRateLeft,
      y1: text_y1,
      y2: text_y1 - rowHeight + 2
    }, {
      ...textInBoxOption,
      xAlign: X_ALIGN_RIGHT,
      xPadding: 2,
      font: fonts.mincho_bold_font,
      size: 12
    });

    // 値入率
    drawTextInBox(page, displaySellingPriceMarkUpRate, {
      x1: dataStart_x + sellingPriceMarkUpRateLeft,
      x2: dataStart_x + orderUnitColumnLeft,
      y1: text_y1,
      y2: text_y1 - rowHeight + 2
    }, {
      ...textInBoxOption,
      xAlign: X_ALIGN_RIGHT,
      xPadding: 2,
      size: 12
    });

  } else if (outputPrice) {
    // 価格・納品価格
    let displayPrice = isShortage ? "-" : price.toLocaleString();
    if (!isShortage && isUsingDeliveryPrice && isUsingOriginalMarketPrice) {
      displayPrice
        = getDeliveryPriceCalculation(deliveryPriceAdditionCd)(price, deliveryPriceAdditionAmount).toLocaleString()
    }

    drawTextInBox(page, displayPrice, {
      x1: dataStart_x + priceColumnLeft,
      x2: dataStart_x + orderUnitColumnLeft,
      y1: text_y1,
      y2: text_y1 - rowHeight + 2
    }, {
      ...textInBoxOption,
      font: fonts.mincho_bold_font,
      xAlign: X_ALIGN_RIGHT,
      xPadding: 2,
      size: 12,
    });
  }

  if (orderQuantityOutput && !skipOrderUnit) {
    Array.from(Array(orderQuantityColumnNumber)).forEach((_, shop_i) => {
      customDrawText(page,outputUnit, {
        x: dataStart_x + orderUnitColumnLeft + shopColumnWidth * (shop_i + 1) - fonts.mincho_font.widthOfTextAtSize(outputUnit, 8) - tableCellPadding * 0.8,
        y: text_y - rowHeight / 2 + 6,
        size: 8,
        font: fonts.mincho_font,
        color: rgb(0, 0, 0),
      })
    })
  }

  // 備考
  if (!skipRemark) {
    drawTextInBox(page, remarks, {
      x1: dataStart_x + remarkColumnLeft,
      x2: dataStart_x + originalMarketPriceLeft,
      y1: text_y1,
      y2: text_y1 - rowHeight + 2
    }, {
      ...textInBoxOption,
      size: 8.5,
      font: fonts.mincho_font,
      xAlign: X_ALIGN_LEFT,
      xPadding: 2,
      lineBreaking: true,
    });     
  }
  
  // 納品価格・案内価格
  if (outputPrice && isUsingOriginalMarketPrice) {
    // 納品価格加算を加算する場合は納品価格を計算　※ただし、入荷未定の場合は計算不可
    // 売価表示設定でない場合は案内価格を表示
    // 売価表示設定かつ営業用出力ではない場合は仲卸業者への納品価格を表示
    // 売価表示設定かつ営業用出力である場合は案内価格を表示
    let displayPrice = (!isShortage && isUsingSellingPrice && isUsingDeliveryPrice && !isViewOriginalCost) ? 
                        getDeliveryPriceCalculation(deliveryPriceAdditionCd)(price, deliveryPriceAdditionAmount) : price;

    drawTextInBox(page, displayPrice.toLocaleString(), {
      x1: dataStart_x + originalMarketPriceLeft,
      x2: dataStart_x + columnWidth,
      y1: text_y1,
      y2: text_y1 - rowHeight + 2
    }, {
      ...textInBoxOption,
      font: fonts.mincho_bold_font,
      xAlign: X_ALIGN_RIGHT,
      xPadding: 2,
      size: 12
    });
  }


}


// フッター
export const createHorizontalOrderFormFooter = (page, pageParameter, marketPriceInfo) => {
  const {
    footerHeight,
    width,
    margin,
    fonts,
    deadlineHourOutput
  } = pageParameter

  const { orderDeadlineHour } = marketPriceInfo;

  const orderDeadline = getAmPmHour(orderDeadlineHour);

  // 発注時間注意
  if (deadlineHourOutput) {
    customDrawText(page,`※発注は、${orderDeadline.amPm}`, {
      x: margin,
      y: margin + footerHeight - 20,
      size: 12,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    })

    customDrawText(page,`${orderDeadline.hour}時`, {
      x: margin + 90,
      y: margin + footerHeight - 20,
      size: 15,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    })

    //時間は２数字ならスペースを開ける
    const orderDeadlineHourSpaceAddition = orderDeadline.hour.toString().length > 1 ? 10 : 0;
    customDrawText(page,'までにお願い致します。', {
      x: margin +  115 + orderDeadlineHourSpaceAddition,
      y: margin + footerHeight - 20,
      size: 12,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    })
  }

  // 青果連絡先
  customDrawText(page, '丸伊伊那青果(株)', {
    x: width - margin - 180,
    y: margin + footerHeight - 20,
    size: 12,
    font: fonts.mincho_font,
    color: rgb(0, 0, 0),
  })

  customDrawText(page, 'TEL: 0265-74-5588', {
    x: width - margin - 80,
    y: margin + footerHeight - 14,
    size: 8,
    font: fonts.mincho_font,
    color: rgb(0, 0, 0),
  })

  customDrawText(page, 'FAX: 0265-73-7210', {
    x: width - margin - 80,
    y: margin + footerHeight - 24,
    size: 8,
    font: fonts.mincho_font,
    color: rgb(0, 0, 0),
  })

}

// 価格表(横)PDF文書作成
async function createHorizontalOrderFormPDFDocumentInfo(
      marketPriceInfo,
      priceInfoList,
      shops,
      destinations,
      isSample,
      shippingDateInfo,
      pdfSetting
  ) {

 const pdfDoc = await createPDFDocument()
  
  //埋込フォント使用
  pdfDoc.registerFontkit(fontkit);
  
  //日本語フォント読込
  const genminchoArrayBuffer = await getFontArrayBuffer(genmincho);
  const genminchoBoldArrayBuffer = await getFontArrayBuffer(genmincho_bold);

  const mincho_font = await pdfDoc.embedFont(genminchoArrayBuffer);
  const mincho_bold_font = await pdfDoc.embedFont(genminchoBoldArrayBuffer);

  const [ height, width ] = PageSizes.A4

  const pageParameter = getHorizontalOrderFormPageParameter(width, height, {mincho_font, mincho_bold_font}, shops, destinations, shippingDateInfo, pdfSetting);
  let {rowNumber, columnNumber, shopSummary, productTypePartition, destinationOutputCd} = pageParameter  
  
  // ページ数の判定
  let productPartitionList = getProductPartitionList(priceInfoList, productTypePartition, rowNumber)

  let columnCount = productPartitionList
      .map((productPartition) => Math.ceil(productPartition.length / rowNumber))
      .reduce((prevCnt, thisCnt) => prevCnt + thisCnt, 0);

  let pageCount = Math.ceil(columnCount / columnNumber);

  // ページの生成
  let pages = Array.from(new Array(pageCount)).map((_) => {
    let page = pdfDoc.addPage([width, height]);
    //createHeader(page, "市況価格表", customerName, shippingDate, pageParameter);
    createHorizontalOrderFormTableBones(page, pageParameter);    
    createHorizontalOrderFormFooter(page, pageParameter, marketPriceInfo);
    return page;
  });

  var lastName = "";
  var lastOrigin = "";
  var lastPriceDetailTypeId = 0;

  var totalDataIndex = 0;

  productPartitionList.forEach((dataList) => {
    if (dataList.length === 0) {
      return;
    }

    totalDataIndex = Math.ceil(totalDataIndex / rowNumber) * rowNumber
    
    dataList.forEach((data, index) => {

      let rowIndex = totalDataIndex % rowNumber;
      let columnIndex = Math.floor(totalDataIndex / rowNumber) % columnNumber;
      let pageIndex = Math.floor(totalDataIndex / (rowNumber * columnNumber));

      let displayOrigin = getDisplayOriginWithOther(data.origin, data.isOriginOther);

      let outputAsFirstOfType
        = !productTypePartition
          && (data.priceDetailTypeId !== lastPriceDetailTypeId)
          && totalDataIndex > 0;

      if (index % rowNumber === 0 || outputAsFirstOfType) {
        lastName = "";
        lastOrigin = "";
      }

      let outputData = {
        ...data,
        name: (lastName === data.productName ? "〃" : data.productName),
        origin: (lastName === data.productName && lastOrigin === displayOrigin ? "〃" : displayOrigin),
        size: getDisplaySize(data.rank, data.productClass, data.weight, data.weightUnit, data.packing, data.quantity),
        price: data.isShortage ? "-" : data.price,
        unit: data.orderingUnit,
        outputAsFirstOfType: outputAsFirstOfType
      }

      outputHorizontalOrderFormTableProductData(pages[pageIndex], pageParameter, rowIndex, columnIndex, outputData);
      
      lastName = data.productName;
      lastOrigin = displayOrigin;
      lastPriceDetailTypeId = data.priceDetailTypeId;

      totalDataIndex += 1;
    })
  })

  pdfDoc.setCreator("丸伊伊那青果　事務担当");

  return await Promise.all((isSample ? [{customerName:marketPriceInfo.marketPriceName,shopName:""}] : destinations).map(async (destinationInfo) => {
    let newPdfDoc = await pdfDoc.copy();
    
    //埋込フォント使用
    newPdfDoc.registerFontkit(fontkit);

    let newFonts = {
      mincho_font: await newPdfDoc.embedFont(genminchoArrayBuffer),
      mincho_bold_font: await newPdfDoc.embedFont(genminchoBoldArrayBuffer)
    }
    let newPageParameter = {...pageParameter, fonts: newFonts};

    return await createHorizontalOrderFormPDFFromDocument(
      marketPriceInfo,
      newPdfDoc,
      "市況価格表",
      getDestinationOutputName(destinationInfo, shopSummary, destinationOutputCd),
      shippingDateInfo,
      newPageParameter
    )
  }))

}

async function createHorizontalOrderFormPDFFromDocument(marketPriceInfo, pdfDoc, title, destinationName, shippingDateInfo, pageParameter) {
  pdfDoc.getPages().forEach((page) => createHorizontalOrderFormHeader(marketPriceInfo, page, title, destinationName, shippingDateInfo, pageParameter))
  
  // 選択されたページに対する余計なページを削除
  const printPages = getPrintPages(pageParameter.printPageStr, pdfDoc.getPageCount())

  const deletePages
    = Array.from(new Array(pdfDoc.getPageCount()))
      .map((_, pageIndex) => pageIndex)
      .filter((pageIndex) => !printPages.includes(pageIndex + 1))
      .reverse();

  deletePages.forEach((pageIndex) => {
    pdfDoc.removePage(pageIndex);
  }) 
  
  return await pdfDoc.save();
}


export async function createHorizontalOrderFormPDF(
  marketPriceId, shops, destinations, isSample, shippingDateInfo, pdfSetting, marketPriceHistoryDate = null
) {
  let marketPriceResponse = await postMarketPriceSearchTableInfoListAPI({marketPriceId, marketPriceHistoryDate});
  let marketPriceInfo = marketPriceResponse.marketPriceTableInfoList[0];
  let res = await postMarketPriceSearchInfoListAPI({marketPriceId, marketPriceHistoryDate});
  let marketPriceInfoList = res.marketPriceInfoList
                .filter((data) => data.isCustomerOrder)
                .map((data)=>({
                  ...data, 
                  price: data.marketPrice,
                  sellingPriceMarkUpRate : data.sellingPriceMarkUpRate || marketPriceInfo.sellingPriceMarkUpRate,
                  primePriceMarkUpRate: data.primePriceMarkUpRate || marketPriceInfo.primePriceMarkUpRate,
                  deliveryPriceAdditionCd: marketPriceInfo.deliveryPriceAdditionCd,
                  deliveryPriceAdditionAmount: marketPriceInfo.deliveryPriceAdditionAmount
                }));
                     
  return await createHorizontalOrderFormPDFDocumentInfo(
    marketPriceInfo,
    marketPriceInfoList,
    shops,
    destinations,
    isSample,
    shippingDateInfo,
    pdfSetting
  );
 
}

// あて名取得
const getDestinationOutputName = (destinationInfo, shopSummary, outputCd) => {
  if (outputCd == 2) {
    return "御取引先様各位";
  }
  if (outputCd == 3) {
    return "　　　　　　　　　　　　様";
  }

  return getOutputDestination(destinationInfo, shopSummary, false);

}
